<!-- MFITTで座席のない号車を選んだ場合 -->
<template>
  <ItemDialog ref="notExistSeat" imageType="alert">
    <template v-slot:content-area>
      <h2>{{ carNumber }}号車は選択できません</h2>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogNotExistSeat",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const notExistSeat = ref(null);
    const carNumber = ref("");

    const openDialog = (car_number) => {
      carNumber.value = car_number;
      notExistSeat.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        notExistSeat.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      notExistSeat,
      carNumber,
      openDialog,
      closeDialog,
    };
  },
};
</script>
